import React from "react";
import {
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import Menu from "../../MainPage/S1_Header/menu";
import { Container, Grid } from "@mui/material";
import styled from "@emotion/styled";

const Heading = styled.div`
  font-weight: 600;
  padding-right: 10px;
`;
const Div = styled.div`
  display: flex;
`;
const Backgurnd = styled.div`
  background-color: rgba(13, 119, 87, 0.15);
  color: #fff;
  border-radius: 20px;
  padding: 20px 20px;
  backdrop-filter: blur(7px);
  max-width: 20%;
  @media screen and (max-width: 599px) {
    max-width: 100%;
  }
`;
const VideoBK = styled.video`
  /* width: 100%;
  height: auto;
  display: block; */
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -1;
`;
const A = styled.a`
  text-decoration: none;
`;
const Index = () => {
  return (
    <div>
      <VideoBK autoPlay loop muted>
        <source src="/images/Kirin.mp4" type="video/mp4" />
      </VideoBK>

      <Menu />
      <SectionWrapper id="explore">
        <Container maxWidth="xl">
          <Grid container>
            <Grid xs={12}>
              <SectionHeading m="20px 0">KIRINOMICS</SectionHeading>
              <br />
              <Backgurnd>
                <Div>
                  <Heading>Ticker:</Heading> $KIRIN
                </Div>

                <Div>
                  <Heading>Total Supply: </Heading> 1 Billion
                </Div>

                <Div>
                  {" "}
                  <Heading>Tax:</Heading> 0/6
                </Div>

                <Div>
                  <Heading>Max Buy:</Heading> 1%
                </Div>
                <Div>
                  <Heading>Max Wallet:</Heading> 2%
                </Div>
                <br />
                <br />

                <Div>
                  {" "}
                  Contract:
                  <A
                    href="https://etherscan.io/address/0x2ac99c198d9b65dbb076a37518bed31d480a0567"
                    target="blank"
                  >
                    0x2...567
                  </A>
                </Div>
              </Backgurnd>
            </Grid>
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default Index;
